import { mutateStepArrayToMap, mutateStepMapToArray } from '@fno/lib/stepped-task-mapper'
import { patchTask, getTabTool } from '@fno/service/api/tasks'

/*

Use it like this:

import { preFormMutator, preSaveMutator, getKeypath, preChangeMutator } from '@fno/route/tab/task/helpers.js'

*/

export const preFormMutator = ({ context }) => {
    if (context.form.schoolOnboarding) {
        mutateStepArrayToMap({ task: context.form.schoolOnboarding })
    }
    if (context.form.clientOnboarding) {
        mutateStepArrayToMap({ task: context.form.clientOnboarding })
    }
}

export const preSaveMutator = ({ context }) => {
    if (context.form.schoolOnboarding) {
        mutateStepMapToArray({ task: context.form.schoolOnboarding })
    }
    if (context.form.clientOnboarding) {
        mutateStepMapToArray({ task: context.form.clientOnboarding })
    }
}

export const getKeypath = ({ formKey, keypath, context }) => {
    if (formKey === 'schoolOnboarding' || formKey === 'clientOnboarding') {
        // Examples:
        // attributes.steps.CLIENT_KICK_OFF.projectChampionName
        // attributes.steps.CLIENT_KICK_OFF.foo.bar.3.baz
        const [ , , stepId, ...remaining ] = keypath.split('.')
        const index = context.form[formKey].attributes.steps[stepId].$index
        return `attributes.steps.${index}.${remaining.join('.')}`
    }
    return keypath
}

export const preChangeMutator = ({ updatedResource, formKey }) => {
    if (formKey === 'schoolOnboarding' || formKey === 'clientOnboarding') {
        mutateStepMapToArray({ task: updatedResource })
    }
}

export const previousHandler = (stateRouter, stepId, schoolId) => () => {
    stateRouter.go(`tab.task.${stepId}`, { schoolId })
}

export const nextHandler = ({ stateRouter, component, save, schoolId, stepId, nextId }) => async (event) => {
    let routeToNextStep = true

    if (event.detail.context.changes) {
        await save(event).catch((error) => {
            routeToNextStep = false
        })
    }

    if (routeToNextStep) {
        component.$set({ saving: 'Marking as complete...' })
        const task = await getTabTool({ schoolId })
        const stepIndex = task.attributes.steps.findIndex((step) => step.id === stepId)
        task.attributes.steps[stepIndex].status = 'COMPLETED'
        await patchTask({ task })
        const resolvedNextId = typeof nextId === 'function' ? nextId(event) : nextId
        stateRouter.go(`tab.task.${resolvedNextId}`, { schoolId })
        component.$set({ saving: false })
    }
}
